// Shared labels & helpers for the Due Diligence data room
export const STAGES = {
  screening: "Screening",
  due_diligence: "Due diligence",
  forhandling: "Forhandling",
  closing: "Closing",
  avsluttet: "Avsluttet",
};

export const STAGE_STYLE = {
  screening: "bg-slate-100 text-slate-700",
  due_diligence: "bg-brand-limeSoft text-brand-limeDark",
  forhandling: "bg-amber-100 text-amber-700",
  closing: "bg-blue-100 text-blue-700",
  avsluttet: "bg-emerald-100 text-emerald-700",
};

export const PERMISSIONS = {
  view: "Kun visning",
  download: "Visning + nedlasting",
  manage: "Full tilgang",
};

export const CHK_STATUS = {
  outstanding: { label: "Utestående", style: "bg-slate-100 text-slate-600" },
  received: { label: "Mottatt", style: "bg-amber-100 text-amber-700" },
  approved: { label: "Godkjent", style: "bg-emerald-100 text-emerald-700" },
};

export const DD_CATEGORIES = [
  "01. Selskap & Juridisk",
  "02. Økonomi & Regnskap",
  "03. Skatt & MVA",
  "04. Ansatte & HR",
  "05. Kommersielt & Kunder",
  "06. Avtaler & Kontrakter",
  "07. IP & Teknologi",
  "08. Eiendom & Anlegg",
  "09. Forsikring",
  "10. Annet",
];

export const DD_SIDES = [
  { key: "kjoper", label: "Kjøper" },
  { key: "selger", label: "Selger" },
];

export const sideLabel = (key) => DD_SIDES.find((s) => s.key === key)?.label || key;
export const otherSide = (key) => (key === "selger" ? "kjoper" : "selger");

export function formatBytes(bytes) {
  if (!bytes && bytes !== 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("nb-NO", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return "";
  }
}

export function formatDateTime(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("nb-NO", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
}

export const ACTIVITY_LABELS = {
  create_deal: "opprettet datarommet",
  upload: "lastet opp",
  download: "lastet ned",
  delete_document: "slettet dokument",
  add_folder: "opprettet mappe",
  checklist: "oppdaterte sjekkliste",
  question: "stilte spørsmål",
  qa_reply: "svarte i Q&A",
  invite: "inviterte",
  remove_member: "fjernet tilgang for",
  preview: "forhåndsviste",
  move_document: "flyttet dokument",
};
